import axios from 'axios';
import request from './axiosFun';

// 登录接口 
export const login = (params) => { return request.post(`/token/login?username=${params.username}&password=${params.password}&captcha=${params.captcha}&randomStr=${params.randomStr}`, params) };
// 获取用户菜单
export const menu = (params) => { return request.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return request.post("/token/logout") };

// 获取所有账号
export const getAllAccounts = (params) => {
    return request({
        url: `/sys/user/accounts`,
        method: 'get',
        params
    });
}

// 切换账号
export const getSwitchAccount = (params) => {
    return request({
        url: `/sys/user/switch/accounts`,
        method: 'get',
        params
    });
}

// 获取跳转 URL（销售主管跳转至销售端）
export const getRedirectUrl = (params) => {
    return request({
        url: '/sys/user/redirect/url',
        method: 'get',
        params
    });
}
/**
 * 用工中心
 **/
// 商户列表
export const getMerchantLsit = (params) => { return request.get(`/sys/user/merchants?page=${params.page}&pageSize=${params.pageSize}&merchantName=${params.merchantName}`, params) }

// 获取所有任务类型
export const gettasksTypes = (params) => { return request.get(`/v1/tasks/types`, params) }

// 获取下发限制
export const getDisLimit = (params) => { return request({ url: '/v1/tasks/dis-limit', method: 'get', params }); }

// 任务列表
export const deptList = (params) => { return request.get(`/v1/tasks?page=${params.page}&pageSize=${params.pageSize}&taskId=${params.taskId}&taskName=${params.taskName}&status=${params.status}&startDate=${params.startDate}&endDate=${params.endDate}&invoiceCategory=${params.invoiceCategory}`, params) };

// 发布任务
export const createDeptList = (params) => { return request.post(`/v1/tasks`, params) }

// 编辑任务
export const editDeptList = (taskId, params) => { return request.put(`/v1/tasks/${taskId}`, params) }

// 获取所有导入任务列表
export const getAllAccountTasks = () => {
    return request({
        url: '/v1/tasks/other/accounts',
        method: 'get',
    });
}

// 导入任务
export const tasksMigration = (params) => {
    return request({
        url: '/v1/tasks/migration',
        method: 'post',
        data: params
    });
}

// 分享任务
export const getQrcodeUrl = (taskId) => {
    return request.get(`/v1/tasks/${taskId}/qrcode`);
}

// 任务报名详情
export const getTaskRegistration = (params) => {
    return request({
        url: `/v1/tasks/${params.taskId}/registration`,
        method: 'get',
        params
    });
}

// 任务报名自由职业者
export const getTaskRegistrationFreelancer = (params) => {
    return request({
        url: `/v1/tasks/${params.taskId}/freelancer-name`,
        method: 'get',
        params
    });
}

export const updateRegistrationStatus = (taskId, freelancerId, params) => {
    return request({
        url: `/v1/tasks/${taskId}/${freelancerId}/registration-status`,
        method: 'put',
        data: params
    });
}

// 批量更新录用状态
export const batchUpdateRegistrationStatus = (taskId, params) => {
    return request({
        url: `/v1/tasks/${taskId}/registration-status`,
        method: 'put',
        data: params
    });
}

// 为任务分配已签约自由职业者（代报名，与自主报名同等写入报名记录）
export const assignFreelancersToTaskRegistration = (taskId, params) => {
    return request({
        url: `/v1/tasks/${taskId}/customer-assign`,
        method: 'post',
        data: params
    });
}

// 任务下已签约且未报名的自由职业者（分页，供代分配选择）
export const getSignedNotRegisteredFreelancers = (taskId, params) => {
    return request({
        url: `/v1/freelancers/${taskId}/signed-not-registered`,
        method: 'get',
        params
    });
}

// 导出所有结算模板
export const getallSettlementTempExcel = (taskId, params) => {
    return request({
        url: `/v1/tasks/${taskId}/settlement-temp`,
        method: 'get',
        params
    });
}

// 导出协议
export const getRegistrationAgreementZip = (taskId, params) => {
    return request({
        url: `/v1/tasks/${taskId}/registration-agreement/zip`,
        method: 'get',
        data: params
    });
}

// 导出记录
export const getRegistrationExportList = (params) => {
    return request({
        url: "/v1/export/registration/logs",
        method: 'get',
        params
    });
}

// 编辑任务状态
export const editDeptListStatus = (taskId, params) => { return request.put(`/v1/tasks/${taskId}/status`, params) }

// 导出数据-任务列表
export const exportTask = (params) => { return request.get(`/v1/tasks/excel?page=${params.page}&pageSize=${params.pageSize}&taskId=${params.taskId}&taskName=${params.taskName}&status=${params.status}&startDate=${params.startDate}&endDate=${params.endDate}`, params) };

// 用工结算单
export const settlementsList = (params) => { return request.get(`/v1/settlements?page=${params.page}&pageSize=${params.pageSize}&status=${params.status}&batchNumber=${params.batchNumber}&startDate=${params.startDate}&endDate=${params.endDate}&taskName=${params.taskName}`, params) };

// 上传结算单
export const settlementsupload = (params) => { return request.post(`/v1/settlements/upload`, params) }

// 导出结算单模板
export const export_template = (params) => { return request.get("/v1/settlements/export/settlement-template", params) };

// 结算单详情
export const settlementsListdetails = (params) => { return request.get(`/v1/settlements/details?page=${params.page}&pageSize=${params.pageSize}&status=${params.status}&detailId=${params.detailId}&batchNumber=${params.batchNumber}&merchantName=${params.merchantName}&idNumber=${params.idNumber}&name=${params.name}&taskName=${params.taskName}&minServiceFee=${params.minServiceFee}&maxServiceFee=${params.maxServiceFee}&transactionStartDate=${params.transactionStartDate}&transactionEndDate=${params.transactionEndDate}&createdStartDate=${params.createdStartDate}&createdEndDate=${params.createdEndDate}&settlementInfo=${params.settlementInfo}&mobile=${params.mobile}`, params) };

// 结算单详情-按状态排序
export const getSettlementDetailsByBatchNumber = (batchNumber, params) => {
    return request({
        url: `/v1/settlements/${batchNumber}/details`,
        method: 'get',
        params
    });
}

// 结算方式
export const getManageFeeAndTaxMode = () => {
    return request({
        url: `/v1/settlements/mode`,
        method: 'get',
    });
}

// 删除结算单详情
export const deleteSettlementDetail = (detailId) => { return request.delete(`/v1/settlements/${detailId}/detail`) };

// 更新结算单详情
export const updateSettlementDetail = (params) => { return request.put(`/v1/settlements/detail`, params) };

//查看任务确认单
export const checksettlementsList = (batchNumber) => { return request.get(`/v1/settlements/${batchNumber}/confirmation-sheet/pdf`) };

//结算详情聚合结果
export const checkAggregationResult = (batchNumber) => { return request.get(`/v1/settlements/${batchNumber}/aggregation-result`) };

// 导出任务确认单
export const exportsettlementsList = (params) => { return request.get(`/v1/settlements/download/confirmation-sheet/zip?batchNumberList=${params.batchNumberList}`, params) };

//导出结算单明细
export const exportsettlementsexcel = (params) => {
    return request({
        url: "/v1/settlements/excel",
        method: 'get',
        params
    });
}

//自由职业者列表
export const freelancerslist = (params) => {
    return request.get(
        `/v1/freelancers?page=${params.page}` +
        `&pageSize=${params.pageSize}` +
        `&name=${params.name}` +
        `&idNumber=${params.idNumber}` +
        `&mobile=${params.mobile}` +
        `&idType=${params.idType}` +
        `&verificationStatus=${params.verificationStatus}` +
        `&faceAuthStatus=${params.faceAuthStatus}` +
        `&receiveAccount=${params.receiveAccount}` +
        `&isPortraitPhoto=${params.isPortraitPhoto}` +
        `&isIdentityPhoto=${params.isIdentityPhoto}` +
        `&signStatus=${params.signStatus}` +
        `&updatedStartDate=${params.updatedStartDate}` +
        `&updatedEndDate=${params.updatedEndDate}` +
        `&signAtStartDate=${params.signAtStartDate}` +
        `&signAtEndDate=${params.signAtEndDate}`,
        params
    );
};
//自由职业者-编辑备注
export const editremarkfreelancers = (params) => { return request.put(`/v1/freelancers/${params.freelancerId}/remark`, params) };

// 是否展示人脸认证状态
export const getShowFaceAuthStatus = (params) => {
    return request({
        url: '/v1/freelancers/show-face-auth-status',
        method: 'get',
        params
    });
};

// 个人认证签约二维码（base64）
export const getPersonalAuthQrcode = (params) => {
    return request({
        url: '/v1/freelancers/personal-auth/qrcode',
        method: 'get',
        params
    });
};

// 自由职业者导出上传模板
export const batchSignTemplate = (params) => { return request.get("/v1/freelancers/batchsigning/template", params) };
// 自由职业者导出数据
export const batchSignUpload = (params) => { return request.post("/v1/freelancers/batchsigning/upload", params) };
// 自由职业者导出数据
export const exportfreelancers = (params) => {
    return request({
        url: "/v1/freelancers/excel",
        method: 'get',
        params
    })
};
// 自由职业者批量导出协议
export const export_agreement = (params) => {
    return request({
        url: "/v1/freelancers/agreement/zip",
        method: 'get',
        params
    })
};
// 自由职业者查看签约协议
export const checkcontractAgreement = (params) => { return request.get(`/v1/freelancers/${params.freelancerId}/contractAgreement`, params) };
// 自由职业者查看身份证照片
export const checkphoto = (params) => { return request.get(`/v1/freelancers/${params.identityDocumentNumber}/photo`, params) };
// 批量导入
export const uploadzip = (params) => { return request.post("/v1/freelancers/identityPhoto/zip", params) };
// 编辑自由职业者
export const updateFreelancer = (params) => {
    return request({
        url: '/v1/freelancers',
        method: 'put',
        data: params
    });
}

export const updateFreelancerAccount = (freelancerId, params) => {
    return request({
        url: `/v1/freelancers/${freelancerId}/account`,
        method: 'put',
        data: params
    });
}

// 编辑自由职业者
export const deleteFreelancer = (params) => {
    return request({
        url: '/v1/freelancers',
        method: 'delete',
        params
    });
}

// 获取所有导入任务列表
export const getAllAccountFreelancers = (params) => {
    return request({
        url: '/v1/freelancers/others',
        method: 'get',
        params
    });
}

// 获取所有导入任务列表
export const migrationFreelancers = (params) => {
    return request({
        url: '/v1/freelancers/migration',
        method: 'post',
        data: params
    });
}

// 导入列表
export const importContractLogs = (params) => {
    return request({
        url: '/v1/import/freelancer/contract/migration/logs',
        method: 'get',
        params
    });
}

// 导入详情列表
export const importContractLogsDtl = (params, id) => {
    return request({
        url: `/v1/import/${id}/logs/dtl`,
        method: 'get',
        params
    });
}


// 导出记录
export const exportlogs = (params) => { return request.get("/v1/export/freelancers/logs", params) };
// 更新结算单状态
export const putSettlementStatus = (batchNumber, params) => { return request.put(`/v1/settlements/${batchNumber}/status`, params) }
// 提交结算单验证
export const settlementsAuth = (params) => { return request.post(`/v1/settlements/auth/confirmation?username=${params.username}&password=${params.password}`, params) };

// 首页
export const getInfo = (params) => { return request.get("/sys/user/info", params) };

/**
 * 消息通知（工作台）
 * 后端需提供：列表（含未读状态）、详情（可选）、标已读
 */
// 消息列表（每条含 id, title, date, content, read）
export const getNoticeList = (params) => {
    return request({
        url: '/v1/message/my/list',
        method: 'get',
        params
    });
};

// 标为已读
export const markNoticeRead = (id) => {
    return request({
        url: `/v1/message/${id}/read`,
        method: 'put'
    });
};

/**
 * 消息通知管理（运营端）
 */
// 管理端-消息列表（分页）
export const getNoticeManageList = (params) => {
    return request({
        url: '/v1/message/list',
        method: 'get',
        params
    });
};
// 新增消息
export const createNotice = (data) => {
    return request({
        url: '/v1/message',
        method: 'post',
        data
    });
};
// 修改消息
export const updateNotice = (id, data) => {
    return request({
        url: `/v1/message/${id}`,
        method: 'put',
        data
    });
};
// 删除消息
export const deleteNotice = (id) => {
    return request({
        url: `/v1/message/${id}`,
        method: 'delete'
    });
};

/**
 * 数据中心
 **/

// 自由职业者结算统计
export const freelanceStatistics = (params) => {
    return request({
        url: "/v1/settlements/freelancer-statistics",
        method: 'get',
        params
    });
}
// 商户结算统计
export const merchantStatistics = (params) => {
    return request({
        url: "/v1/settlements/merchant-statistics",
        method: 'get',
        params
    });
}

// 导出数据-自由职业者结算统计
export const exportfreelancerstatistics = (params) => {
    return request({
        url: "/v1/settlements/freelancer-statistics/excel",
        method: 'get',
        params
    });
}
// 导出数据-商户结算数据统计
export const exportmerchantstatistics = (params) => {
    return request({
        url: "v1/settlements/merchant-statistics/excel",
        method: 'get',
        params
    });
}

// 导出完税模板
export const exportPaymentCertificateTmp = (merchantId, disCompanyId, month) => {
    return request({
        url: `v1/settlements/${merchantId}/${disCompanyId}/${month}/payment-certificate`,
        method: 'get'
    });
}

// 批量导出完税模板
export const batchExportPaymentCertificateTmp = (disCompanyId, month, params) => {
    return request({
        url: `v1/settlements/${disCompanyId}/${month}/payment-certificate`,
        method: 'get',
        params
    });
}

// 批量导出完税模板-导出记录
export const exportPayCertlogs = (params) => {
    return request({
        url: "/v1/export/payment-certificate/logs",
        method: 'get',
        params
    });
}

// 导出数据-批次明细交易信息查询
export const exportsettlements = (params) => {
    return request({
        url: "/v1/settlements/excel",
        method: 'get',
        params
    });
}

/**
 * 财务中心
 **/
// 商户余额
export const merchantBalance = (params) => {
    return request({
        url: '/sys/user/merchants/balance',
        method: 'get',
        params
    });
}
// 收款信息
export const receiptInfo = (params) => { return request.get("/v1/receipt-info", params) };
// 账单列表
export const billsList = (params) => { return request.get(`/v1/bills?page=${params.page}&pageSize=${params.pageSize}&operationType=${params.operationType}&startDate=${params.startDate}&endDate=${params.endDate}`, params) };
// 充值记录
export const rechargeRecords = (params) => { return request.get(`/v1/recharge-records?page=${params.page}&pageSize=${params.pageSize}&merchantName=${params.merchantName}&startDate=${params.startDate}&endDate=${params.endDate}&rechargeStatus=${params.rechargeStatus}&canInvoice=${params.canInvoice}`, params) };
// 开票记录
//export const invoiceRecords = (params) => { return request.get(`/v1/invoice/records?page=${params.page}&pageSize=${params.pageSize}&recordStatus=${params.recordStatus}&startDate=${params.startDate}&endDate=${params.endDate}&invoiceCategory=${params.invoiceCategory}&recordId=${params.recordId}&merchantName=${params.merchantName}`, params) };
export const invoiceRecords = (params) => {
    return request({
        url: '/v1/invoice/records',
        method: 'get',
        params
    });
}
// 开票信息
export const invoiceInfo = (params) => { return request.get("/v1/invoice/info", params) };
//新增开票信息
export const addInvoiceInfo = (params) => {
    return request({
        url: "/v1/invoice/info",
        method: 'post',
        data: params
    });
}
// 更新开票信息
export const updateInvoiceInfo = (params) => {
    return request({
        url: "/v1/invoice/info",
        method: 'put',
        data: params
    });
}
// 开票详情
export const invoicedetails = (recordId) => { return request.get(`/v1/invoice/${recordId}/details`) };
// 删除开票详情
export const deleteInvoiceDtl = (params) => {
    return request({
        url: "/v1/invoice/detail",
        method: 'delete',
        params
    });
};
// 电子回单
export const settlementsEreceipts = (params) => {
    return request({
        url: '/v1/settlements/details',
        method: 'get',
        params
    });
}


// 收款信息
export const invoiceCategory = (params) => { return request.get("/v1/invoice-category", params) };
// 完税证明
export const taxCertificates = (params) => { return request.get(`/v1/tax-certificates?page=${params.page}&pageSize=${params.pageSize}&taxDate=${params.taxDate}&distributeCompany=${params.distributeCompany}&fileName=${params.fileName}`, params) };
// 导出账单列表
export const billexcel = (params) => {
    return request({
        url: "/v1/bills/excel",
        method: 'get',
        params
    });
}

// 导出充值记录
export const recordsexcel = (params) => {
    return request({
        url: "/v1/recharge-records/excel",
        method: 'get',
        params
    });
}
// 开票记录-导出记录
export const exportinvoicelogs = (params) => { return request.get("/v1/export/invoice/logs", params) };
// 开票记录-导出数据
export const exportinvoicerecords = (params) => {
    return request({
        url: "/v1/invoice/records/excel",
        method: 'get',
        params
    });
}
// 开票记录-导出发票
export const invoicezip = (params) => {
    return request({
        url: '/v1/invoice/zip',
        method: 'get',
        params
    });
}

// 查看电子回单
export const checkeceipts = (detailId, params) => { return request.get(`/v1/settlements/${detailId}/e-receipts`, params) };
// 导出电子回单
export const exportreceipts = (params) => {
    return request({
        url: '/v1/settlements/e-receipts/zip',
        method: 'get',
        params
    });
}

// 查看完税证明
export const checkcertificates = (id, params) => { return request.get(`/v1/tax-certificates/${id}/pdf`, params) };
// 导出账单列表
export const exportcertificates = (params) => { return request.get("/v1/tax-certificates/zip", params) };
// 申请开票
export const createinvoicerecords = (params) => { return request.post(`/v1/invoice/records`, params) }
// 下载收款信息
export const downloadreceiptinfo = (params) => { return request.get(`/v1/receipt-info/pdf`, params) }
// 开票类目
export const getinvoiceCategory = (params) => { return request.get(`/v1/invoice/categories`, params) }
// 发票类型
export const getinvoicetypes = (params) => { return request.get(`/v1/invoice/types?page=1&pageSize=20`, params) }
// 充值记录查看金额明细
export const getamountdetail = (rechargeId) => { return request.get(`/v1/invoice/${rechargeId}/amount-detail`) }
// 获取可开票结算批次列表
export const getSettlementBatchForInvoice = (params) => {
    return request.get(`/v1/settlements?page=${params.page}&pageSize=${params.pageSize}&startDate=${params.startDate}&endDate=${params.endDate}&batchNumber=${params.batchNumber || ''}&canInvoice=${params.canInvoice}`, params)
}

// 上传发票
export const uploadInvoiceDetail = (params) => {
    return request({
        url: '/v1/invoice/detail',
        method: 'post',
        data: params
    });
}
// 更新发票状态
export const updateRecordStatus = (params) => {
    return request({
        url: '/v1/invoice/record-status',
        method: 'put',
        data: params
    });
}

// 抵扣预开
export const deductPreIssued = (recordId) => {
    return request({
        url: `/v1/invoice/deduct/${recordId}/pre_issued/amount`,
        method: 'post',
    });
}

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => {
    return request({
        url: "/sys/user/password",
        method: 'put',
        data: params
    });
}
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/api/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };


/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };

// 服务商列表
export const getDisCompanyNames = (params) => {
    return request({
        url: '/v1/company/names',
        method: 'get',
        params
    });
}

/**
 * 管理中心
 **/

// 合同管理
export const getContractInfo = (params) => {
    return request({
        url: '/sys/user/contract',
        method: 'get',
        params
    });
};

// 代理商
// 信息
export const getAgentUserInfo = (params) => {
    return request({
        url: '/v1/agent/info',
        method: 'get',
        params
    });
};
export const updateAgentPayeeInfo = (params) => {
    return request({
        url: '/v1/agent/payee-info',
        method: 'put',
        data: params
    });
};
// 统计数据
export const getAgentStatisticsData = (params) => {
    return request({
        url: '/v1/agent/statistics-data',
        method: 'get',
        params
    });
};

// 结算批次
export const getAgentSettlementBatch = (params) => {
    return request({
        url: '/v1/agent/settlement-batch',
        method: 'get',
        params
    });
};
// 导出结算批次excel
export const exportAgentSettlementBatch = (params) => {
    return request({
        url: '/v1/agent/settlement-batch/excel',
        method: 'get',
        params
    });
};

// 商户统计
export const getAgentMerchantStatistical = (params) => {
    return request({
        url: '/v1/agent/merchant/statistical',
        method: 'get',
        params
    });
};

// 结算时间
export const getAgentMerchantSettlementTime = (params) => {
    return request({
        url: '/v1/agent/merchant/settlement/times',
        method: 'get',
        params
    });
};

// 商户列表
export const getMerchants = (params) => {
    return request({
        url: '/v1/agent/merchants',
        method: 'get',
        params
    });
};

// 商户名字
export const getMerchantName = (params) => {
    return request({
        url: '/v1/agent/merchants/name',
        method: 'get',
        params
    });
};

// 代理商费率
export const getAgentRate = (params) => {
    return request({
        url: '/v1/agent/rate',
        method: 'get',
        params
    });
};

/**
 * 销售
 */

// 统计数据
export const getSalesStatisticsData = (params) => {
    return request({
        url: '/v1/sales/statistics-data',
        method: 'get',
        params
    });
};

// 批次数据
export const getSalesSettlementBatch = (params) => {
    return request({
        url: '/v1/sales/settlement-batch',
        method: 'get',
        params
    });
};

// 结算时间
export const getSalesMerchantSettlementTime = (params) => {
    return request({
        url: '/v1/sales/merchant/settlement/times',
        method: 'get',
        params
    });
};

// 商户统计
export const getMerchantStatistical = (params) => {
    return request({
        url: '/v1/sales/merchant/statistical',
        method: 'get',
        params
    });
};

// 商户
export const getSalesMerchants = (params) => {
    return request({
        url: '/v1/sales/merchants',
        method: 'get',
        params
    });
};

// 检索商户
export const searchMerchants = (params) => {
    return request({
        url: '/v1/sales/search/merchants',
        method: 'get',
        params
    });
};

// 商户名字
export const getSalesMerchantName = (params) => {
    return request({
        url: '/v1/sales/merchant/names',
        method: 'get',
        params
    });
};

// 商户月度下发数据（按月的统计）
export const getMerchantMonthlyDistribution = (params) => {
    return request({
        url: '/v1/sales/merchant/monthly-statistics',
        method: 'get',
        params
    });
};

// 所有客户月度流水列表（含 monthlyData，用于折线图）
export const getSalesAllCustomersMonthlyFlowList = (params) => {
    return request({
        url: '/v1/sales/customer-monthly-flow',
        method: 'get',
        params
    });
};

/**
 * 销售主管 - 团队管理
 */
// 团队内销售人员列表
export const getTeamSalesList = (params) => {
    return request({
        url: '/v1/sales/team/members',
        method: 'get',
        params
    });
};
// 新增销售到团队
export const addTeamSales = (params) => {
    return request({
        url: '/v1/sales',
        method: 'post',
        data: params
    });
};
// 修改团队内销售
export const updateTeamSales = (params) => {
    return request({
        url: '/v1/sales',
        method: 'put',
        data: params
    });
};
// 从团队移除销售
export const removeTeamSales = (id, params) => {
    return request({
        url: `/v1/sales/team/${id}/members`,
        method: 'delete',
        data: params
    });
};

// 销售主管首页统计数据
export const getSalesLeaderHomeStats = (params) => {
    return request({
        url: '/v1/sales/team/leader-home-stats',
        method: 'get',
        params
    });
};

// 销售主管 - 团队商户列表
export const getSalesTeamMerchants = (params) => {
    return request({
        url: '/v1/sales/team/merchants',
        method: 'get',
        params
    });
};

// 销售主管 - 团队下客户结算批次
export const getSalesTeamSettlementBatch = (params) => {
    return request({
        url: '/v1/sales/team/settlement-batch',
        method: 'get',
        params
    });
};

// 销售主管 - 团队下客户月度流水
export const getSalesTeamCustomerMonthlyFlow = (params) => {
    return request({
        url: '/v1/sales/team/customer-monthly-flow',
        method: 'get',
        params
    });
};

// 销售主管 - 各销售月度流水（按销售分条折线）
export const getSalesTeamSalesMonthlyFlow = (params) => {
    return request({
        url: '/v1/sales/team/sales-monthly-flow',
        method: 'get',
        params
    });
};

// 销售主管 - 团队月度毛利
export const getSalesTeamMonthlyGrossProfit = (params) => {
    return request({
        url: '/v1/sales/team/monthly-gross-profit',
        method: 'get',
        params
    });
};

// 销售 - 月度毛利（当前销售所有客户）
export const getSalesMonthlyGrossProfit = (params) => {
    return request({
        url: '/v1/sales/monthly-gross-profit',
        method: 'get',
        params
    });
};

// 销售主管 - 各销售月度毛利（按销售分条折线）
export const getSalesTeamSalesMonthlyGrossProfit = (params) => {
    return request({
        url: '/v1/sales/team/sales-monthly-gross-profit',
        method: 'get',
        params
    });
};

// 销售主管 - 团队月度签约数量
export const getSalesTeamMonthlySignCount = (params) => {
    return request({
        url: '/v1/sales/team/monthly-sign-count',
        method: 'get',
        params
    });
};

// 销售主管 - 各销售月度签约（按销售分条折线）
export const getSalesTeamSalesMonthlySignCount = (params) => {
    return request({
        url: '/v1/sales/team/sales-monthly-sign-count',
        method: 'get',
        params
    });
};

// 签单表
export const getCustomerSignOrders = (params) => {
    return request({
        url: '/v1/oms/sign/orders',
        method: 'get',
        params
    });
};

// 新增签单表
export const saveCustomerSignOrders = (params) => {
    return request({
        url: '/v1/oms/sign/orders',
        method: 'post',
        data: params
    });
};

// 修改签单表
export const updateCustomerSignOrders = (params) => {
    return request({
        url: '/v1/oms/sign/orders',
        method: 'put',
        data: params
    });
};

// 删除签单表
export const deleteCustomerSignOrders = (params) => {
    return request({
        url: '/v1/oms/sign/orders',
        method: 'delete',
        data: params
    });
};

// 列表
export const getCompanyNameList = (params) => {
    return request({
        url: '/v1/company/names',
        method: 'get',
        params
    });
};

// 改价记录
export const getChangePriceRecords = (params) => {
    return request({
        url: '/v1/oms/change/price/records',
        method: 'get',
        params
    });
};

export const matchSettlementTemplate = (params) => { return request.get("/v1/oms/match/settlement/template", params) };

// 匹配结算单
export const matchSettlement = (params) => {
    return request({
        url: '/v1/oms/match/settlement',
        method: 'post',
        data: params
    });
};

// 导入日志
export const importLogs = (params) => {
    return request({
        url: '/v1/import/logs',
        method: 'get',
        params
    });
}

// 导入详情列表
export const logDtl = (params, id) => {
    return request({
        url: `/v1/import/${id}/logs/dtl`,
        method: 'get',
        params
    });
}

// ========== 白名单管理（自由职业者四要素） ==========
// 白名单列表
export const getWhitelistList = (params) => {
    return request({
        url: '/v1/oms/freelancer-whitelist/list',
        method: 'get',
        params
    });
};
// 新增白名单  POST /v1/oms/freelancer-whitelist
export const createWhitelist = (data) => {
    return request({
        url: '/v1/oms/freelancer-whitelist',
        method: 'post',
        data
    });
};
// 修改白名单  PUT /v1/oms/freelancer-whitelist/{id}
export const updateWhitelist = (data) => {
    const id = data.id;
    return request({
        url: `/v1/oms/freelancer-whitelist/${id}`,
        method: 'put',
        data
    });
};
// 删除白名单  DELETE /v1/oms/freelancer-whitelist/{id}
export const deleteWhitelist = (params) => {
    const id = typeof params === 'object' ? params.id : params;
    return request({
        url: `/v1/oms/freelancer-whitelist/${id}`,
        method: 'delete'
    });
};
// 批量导入白名单（上传文件，FormData 包含 file 字段） POST /v1/oms/freelancer-whitelist/batch-excel
export const batchImportWhitelist = (formData) => {
    return request({
        url: '/v1/oms/freelancer-whitelist/batch-excel',
        method: 'post',
        data: formData
    });
};


// WEBPACK FOOTER //
// ./src/api/userMG.js